<ng-container *ngIf="['subheading-body'].indexOf(block.fields['format']) > -1">
  <div class="block-text-columns-container align-self-flex-start">
    <h3 class="lcp-subheading text-color-light" 
      *ngIf="block.fields['title']">
      <p class="font-logo">
        {{ block.fields['title'] }}
      </p>
    </h3>
  </div>
  <div class="block-text-columns-container align-self-flex-start">
    <div class="block-body"
      *ngIf="block.fields['body']"
      [innerHtml]="lcpHelper.htmlFromRichText(block.fields['body'])">
    </div>
  </div>
</ng-container>

<ng-container *ngIf="['body-h4'].indexOf(block.fields['format']) > -1">
  <div class="block-body-h4-container">
    <div class="block-text-columns-container align-self-flex-start">
      <div class="block-body"
        *ngIf="block.fields['body']"
        [innerHtml]="lcpHelper.htmlFromRichText(block.fields['body'])">
      </div>
    </div>
    <div class="block-text-columns-container align-self-flex-start">
      <h4 class="block-body-h4-heading text-color-light" 
        *ngIf="block.fields['title']">
        {{ block.fields['title'] }}
      </h4>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="['h4-body'].indexOf(block.fields['format']) > -1">
  <div class="block-h4-body-container">
    <div class="block-text-columns-container block-h4-body-flex-left align-self-flex-start">
      <h4 class="block-h4-body-heading text-color-light" 
        *ngIf="block.fields['title']">
        {{ block.fields['title'] }}
      </h4>
    </div>
    <div class="block-text-columns-container block-h4-body-flex-right align-self-flex-start">
      <div class="block-body"
        *ngIf="block.fields['body']"
        [innerHtml]="lcpHelper.htmlFromRichText(block.fields['body'])">
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="['full-width'].indexOf(block.fields['format']) > -1">
  <lcp-media
    [media]="block.fields['media'][0]"
    klass="block-image is-full">
  </lcp-media>
</ng-container>

<ng-container *ngIf="['two-square'].indexOf(block.fields['format']) > -1">
  <lcp-media
    [media]="block.fields['media'][0]"
    klass="block-image is-half">
  </lcp-media>
  <lcp-media
    [media]="block.fields['media'][1]"
    klass="block-image is-half">
  </lcp-media>
</ng-container>

<ng-container *ngIf="block.fields['format'] == 'image-block-3'">
  <lcp-media
    [media]="block.fields['media'][0]"
    klass="block-image is-half">
  </lcp-media>

  <div class="block-column">
    <lcp-media
      [media]="block.fields['media'][1]"
      klass="block-image is-full">
    </lcp-media>
    <lcp-media
      [media]="block.fields['media'][2]"
      klass="block-image is-full">
    </lcp-media>
  </div>
</ng-container>

<ng-container *ngIf="block.fields['format'] == 'image-block-4'">
  
  <div class="block-column">
    <lcp-media
      [media]="block.fields['media'][0]"
      klass="block-image is-full">
    </lcp-media>
    <lcp-media
      [media]="block.fields['media'][1]"
      klass="block-image is-full">
    </lcp-media>
  </div>

  <lcp-media
    [media]="block.fields['media'][2]"
    klass="block-image is-half">
  </lcp-media>
</ng-container>


<ng-container *ngIf="block.fields['format'] == 'image-block-5'">
  <lcp-media
    [media]="block.fields['media'][0]"
    klass="block-image is-half">
  </lcp-media>

  <div class="block-column">
    <lcp-media
      [media]="block.fields['media'][1]"
      klass="block-image is-full">
    </lcp-media>

    <div class="block-column">
      <lcp-media
        [media]="block.fields['media'][2]"
        klass="block-image is-full">
      </lcp-media>
    </div>
    <div class="block-column">
      <lcp-media
        [media]="block.fields['media'][3]"
        klass="block-image is-full">
      </lcp-media>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="block.fields['format'] == 'image-block-6'">
  <div class="block-column">
    <lcp-media
      [media]="block.fields['media'][0]"
      klass="block-image is-full">
    </lcp-media>

    <div class="block-column">
      <lcp-media
        [media]="block.fields['media'][1]"
        klass="block-image is-full">
      </lcp-media>
    </div>
    <div class="block-column">
      <lcp-media
        [media]="block.fields['media'][2]"
        klass="block-image is-full">
      </lcp-media>
    </div>
  </div>

  <lcp-media
    [media]="block.fields['media'][3]"
    klass="block-image is-full">
  </lcp-media>
</ng-container>

<ng-container *ngIf="block.fields['format'] == 'image-block-7'">
  <div class="block-column is-1-4">
    <lcp-media
      [media]="block.fields['media'][0]"
      klass="block-image is-full">
    </lcp-media>
  </div>
  <div class="block-column is-3-4">
    <lcp-media
      [media]="block.fields['media'][1]"
      klass="block-image is-full">
    </lcp-media>
  </div>
</ng-container>

<ng-container *ngIf="block.fields['format'] == 'image-block-8'">
  <div class="block-column is-3-4">
    <lcp-media
      [media]="block.fields['media'][0]"
      klass="block-image is-full">
    </lcp-media>
  </div>
  <div class="block-column is-1-4">
    <lcp-media
      [media]="block.fields['media'][1]"
      klass="block-image is-full">
    </lcp-media>
  </div>
</ng-container>